import { render } from "./agendashboard.vue?vue&type=template&id=1f5378fa"
import script from "./agendashboard.vue?vue&type=script&lang=js"
export * from "./agendashboard.vue?vue&type=script&lang=js"

import "./agendashboard.vue?vue&type=style&index=0&id=1f5378fa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__